/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-25 13:45:04
 */

export default {
  path: "publicTask",
  component: () =>
    import(/* webpackChunkName: "position-list" */ "@/pages/publicTask/List"),
  meta: { title: "任务发布", cate: "结算管理" },
  children: [
    {
      path: 'personnelList',
      component: () => import( /* webpackChunkName: "company-list" */ '@/pages/publicTask/personnelList/index'),
      meta: {
        title: '报名审核',
        cate: '结算管理'
      }
    }
  ],
};
